package net.sergeych.ugdx.shared

import kotlinx.datetime.Instant
import kotlinx.serialization.Serializable

@Serializable
data class ServiceMessage(
    val type: Type,
    val message: String,
    val createdAt: Instant
) {
    enum class Type {
        INFORMATIONAL, WARNING, ERROR
    }
}
